// extracted by mini-css-extract-plugin
module.exports = {"page":"Login_page__27pKy","container":"Login_container__3g5c8","headerImage":"Login_headerImage__1QTg9","heading":"Login_heading__2GvJc"};